import { z } from 'zod';

import { OrganizationId, SubscriptionError, SubscriptionErrorKnownValue } from 'backend-client-web';

import { makeProtobufEnumSchema, makeExcludeValuesTransform } from '../enumSchemas';
import objectPassthrough from '../objectPassthrough';
import { WithUnknownValuePlaceholder } from '../unknownValuePlaceholder';

// Note that we set these schemas to passthrough to avoid confusing situations where
// ServerSideSettings are invisible in the client due to typos.

interface ServerSideSettings {
  // "groups" for compatibility, "teams" everywhere else
  readonly groups?: {
    readonly enable: boolean;
  };
  readonly persistLastKnownSyncVersion?: boolean;
  readonly migrateToProfiles?: boolean;
  readonly injectSubscriptionError?: Record<
    OrganizationId,
    WithUnknownValuePlaceholder<SubscriptionErrorKnownValue, undefined>
  >;
  readonly allowLoginInbox?: boolean;
  readonly lfdAdmin?: boolean;
  readonly showInternalBetas?: boolean;
  readonly showTroubleshootingDeleteAllLoginHistory?: boolean;
}

const schemaGroups = objectPassthrough({
  enable: z.boolean(),
});

const schemaSubscriptionErrorKnownValueWithPlaceholder = makeProtobufEnumSchema(
  SubscriptionError,
  undefined,
).transform(makeExcludeValuesTransform(SubscriptionError.OK));

const ServerSideSettings = objectPassthrough({
  groups: schemaGroups.optional(),
  persistLastKnownSyncVersion: z.boolean().optional(),
  migrateToProfiles: z.boolean().optional(),
  migrateRedundantPrivateProfile: z.boolean().optional(),
  injectSubscriptionError: z
    .record(z.string(), schemaSubscriptionErrorKnownValueWithPlaceholder)
    .optional(),
  allowLoginInbox: z.boolean().optional(),
  lfdAdmin: z.boolean().optional(),
  showInternalBetas: z.boolean().optional(),
});

export { ServerSideSettings };
